import { useMemo } from 'react';

import { useShowBackerInfo } from '@givebacks/api/backer';
import { isChrome, isDesktop } from 'react-device-detect';

export const useExtensionAdded = () => {
  const { data: backer, isLoading } = useShowBackerInfo();
  const extensionAdded = useMemo(
    () =>
      isDesktop ? backer?.home?.chrome_extension_enabled : backer?.home?.mobile_extension_enabled,
    [backer?.home?.chrome_extension_enabled, backer?.home?.mobile_extension_enabled]
  );

  const showExtensionCTA = useMemo(() => {
    if (isLoading) {
      return false;
    }
    if (isDesktop && !isChrome) {
      return false;
    }

    return !extensionAdded;
  }, [extensionAdded, isLoading]);

  return { showExtensionCTA };
};
